import {ProfilePageConfig} from 'main/content/pages/profile/ProfilePageConfig';

export const pagesConfigs = [
    ProfilePageConfig
];


// WEBPACK FOOTER //
// ./src/main/content/pages/pagesConfigs.js